var globalThis = require('globalthis/polyfill')()

;(function () {
  'use strict'

  /**
   related issue: https://github.com/Semantic-Org/Semantic-UI/issues/6449
   Apparently, Semantic-ui cancels every 'touchmove' event when the current page has the class 'dimmer', that's why the scroll doesn't work on mobile phones...
   This basically cancels the 'touchmove' event propagation, so semantic-ui does not cancel it
   */
  EventTarget.prototype.addEventListenerBase = EventTarget.prototype.addEventListener
  EventTarget.prototype.addEventListener = function (type, listener) {
    const that = this ? this : globalThis

    const addEvent = function () {
      if (that !== document.querySelector('body') || type !== 'touchmove') {
        that.addEventListenerBase(type, listener)
      }
    }

    try {
      if (this.activeElement && this.activeElement.classList && this.activeElement.classList.contains('Vitally--TextArea-input')) {
        return
      }

      addEvent()
    } catch (e) {
      addEvent()
    }
  }
})()
